import { IOpsScheduleDay } from '@nkr/models/index';

export interface IDayWithValidation extends IOpsScheduleDay {
    validStartTime: boolean,
    validEndTime: boolean
}
